import { forwardRef, type Ref, type SVGProps } from "react";

function SvgSunFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <g fill="currentColor" clipPath="url(#sun_filled_svg__a)">
        <path d="M8.667 1.333a.667.667 0 0 0-1.334 0V2a.667.667 0 0 0 1.334 0zm0 12.667a.667.667 0 1 0-1.334 0v.667a.667.667 0 0 0 1.334 0zm4.518-11.185c.26.26.26.683 0 .943l-.474.473a.667.667 0 1 1-.943-.942l.474-.474c.26-.26.682-.26.943 0m-8.954 9.896a.667.667 0 1 0-.942-.942l-.474.473a.667.667 0 1 0 .943.943zM13.333 8c0-.368.299-.667.667-.667h.667a.667.667 0 1 1 0 1.334H14A.667.667 0 0 1 13.333 8m-12-.667a.667.667 0 0 0 0 1.334H2a.667.667 0 0 0 0-1.334zm10.436 4.436c.26-.26.682-.26.942 0l.474.473a.667.667 0 0 1-.943.943l-.474-.474a.667.667 0 0 1 0-.942m-8.01-8.954a.667.667 0 1 0-.943.943l.474.473a.667.667 0 1 0 .942-.942zm1.414 2.357a4 4 0 1 1 5.656 5.656 4 4 0 0 1-5.656-5.656" />
      </g>
      <defs>
        <clipPath id="sun_filled_svg__a">
          <path fill="currentColor" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgSunFilled);
export default ForwardRef;
